import { Button, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionProfiles extends Layout {
    buttonOpenPortals: Button;
    emailptable: Table;
    lblActions: Label;
    lblApps: Label;
    lblDocProf: Label;
    lblDocs: Label;
    pbAddDocProf: Button;
    pbAddSeq: Button;
    pbDelDocProf: Button;
    pbDelSeq: Button;
    pbDownSeq: Button;
    pbUpSeq: Button;
    pnlButtons: Panel;
    pnlLeft: Panel;
    pnlMid: Panel;
    pnlRight: Panel;
    pnlTop: Panel;
    sourceDpsqlh: DataSource;
    sourceDxfunction: DataSource;
    sourceDxmasterp: DataSource;
    sourceDxproject: DataSource;
    sourceImapCats: DataSource;
    sourceImgApps: DataSource;
    sourceRendOverrideProfiles: DataSource;
    sourceRenditionDocumentProfiles: DataSource;
    sourceRenditionEmailProfiles: DataSource;
    sourceRenditionFaxProfiles: DataSource;
    sourceRenditionFilterProfiles: DataSource;
    sourceRenditionFtpProfiles: DataSource;
    sourceRenditionLogixProfiles: DataSource;
    sourceRenditionOverrideProfiles: DataSource;
    sourceRenditionProperties: DataSource;
    sourceRenditionRuleProfiles: DataSource;
    sourceRenditionTypes: DataSource;
    sourceRenlgxpflds2: DataSource;
    tabTab1: Tab;
    tabTab2: Tab;
    tabTab3: Tab;
    tabTab4: Tab;
    tabTab5: Tab;
    tabTab6: Tab;
    tabTab7: Tab;
    tabTab8: Tab;
    tabTab9: Tab;
    table2: Table;
    table3: Table;
    table4: Table;
    table5: Table;
    table7: Table;
    table8: Table;
    tabset1: Tabset;
    tbDocProf2: Textbox;
    tbDocProf3: Textbox;
    tbOverrideProfiles: Textbox;
    tbOvrhDesc: Textbox;
    tbOvrhId: Textbox;
    tblApps: Table;
    tblDocProf: Table;
    tblDocs: Table;
    tblLogixProfiles: Table;
    textboxOvrhId: Textbox;
}
